import { render, staticRenderFns } from "./CardBanner.vue?vue&type=template&id=78fe2fae&scoped=true"
import script from "./CardBanner.vue?vue&type=script&lang=js"
export * from "./CardBanner.vue?vue&type=script&lang=js"
import style0 from "./CardBanner.vue?vue&type=style&index=0&id=78fe2fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe2fae",
  null
  
)

export default component.exports